import React, { useState, memo } from "react";
import { graphql } from "gatsby";
import Section from "../components/section";
import ThreeJsComponent from "../3D/scene";
import GlobalStyle from "../styles/globalStyles";
import Loader from "../components/loader";
import { LandingWrapper } from "../styles/components/section";

const MemoizedThreeJsComponent = memo(ThreeJsComponent);

const IndexPage = ({ data }) => {
  const [isLoaded, setIsLoaded] = useState(false);

  const disableLoader = () => {
    setIsLoaded(true);
  };

  return (
    <>
      <GlobalStyle />
      <Loader isLoaded={isLoaded} />
      <MemoizedThreeJsComponent disableLoader={disableLoader} />
      <LandingWrapper id="landing-wrapper">
        <Section
          datoContentData={data.allDatoCmsBespokeStory.edges[0].node.content}
          heroImage={data.allDatoCmsBespokeStory.edges[0].node.heroImage}
        />
      </LandingWrapper>
    </>
  );
};

export default IndexPage;

export const query = graphql`
  query StoryQuery {
    allDatoCmsBespokeStory(
      filter: { id: { eq: "DatoCmsBespokeStory-C1ojZeQxSIWSVr8pLCa1ig-en" } }
    ) {
      edges {
        node {
          id
          title
          heroImage {
            fluid {
              src
              srcSet
              aspectRatio
            }
          }
          content {
            ...DatoAgeGateFragment
            ...DatoArticleAggregatorFragment
            ...DatoCreditFragment
            ...DatoCtaFragment
            ...DatoCustomMarkupFragment
            ...DatoGalleryFragment
            ...DatoHeadlineFragment
            ...DatoHeroFragment
            ...DatoImageFragment
            ...DatoImageTextFragment
            ...DatoInterviewFragment
            ...DatoLayoutDividerFragment
            ...DatoLoaderFragment
            ...DatoMarqueeFragment
            ...DatoParagraphFragment
            ...DatoProgressBarFragment
            ...DatoQuoteFragment
            ...DatoSeparatorFragment
            ...DatoShoppingCarouselFragment
            ...DatoSvgFragment
            ...DatoVideoFragment
            ...DatoVideoMuxFragment
            ...DatoKeyValuePairFragment
          }
        }
      }
    }
  }
`;
